import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Award, Star } from "lucide-react";

const RESULTS_IMG = "https://customer-assets.emergentagent.com/job_exam-excellence-hub/artifacts/1bm2ddrx_ChatGPT%20Image%20Mar%205%2C%202026%2C%2002_53_33%20AM.png";

const toppers = [
  {
    name: "Ravishankar Paswan",
    score: "93.82 Percentile | Rank 627",
    exam: "JEE Mains",
    college: "",
    tag: "JEE",
    tagColor: "#1e40af",
    initials: "RP",
  },
  {
    name: "Vishal Savase",
    score: "Boards 91.4% | MHT-CET 95.49 Percentile",
    exam: "BAMS",
    college: "BAMS College",
    tag: "MHT-CET",
    tagColor: "#9a3412",
    initials: "VS",
  },
  {
    name: "Jitendra Yadav",
    score: "MHT-CET 94.967 Percentile",
    exam: "PCB Group",
    college: "",
    tag: "MHT-CET",
    tagColor: "#9a3412",
    initials: "JY",
  },
  {
    name: "Umair Khan",
    score: "NEET 532 Marks",
    exam: "IIMSR Jalna",
    college: "IIMSR Jalna",
    tag: "NEET",
    tagColor: "#166534",
    initials: "UK",
  },
  {
    name: "Hitesh Gupta",
    score: "JEE 90.24 Percentile",
    exam: "Bachelors in Architecture",
    college: "B.Arch College",
    tag: "JEE",
    tagColor: "#1e40af",
    initials: "HG",
  },
  {
    name: "Deepti Gupta",
    score: "NEET 554 Marks",
    exam: "MBBS – Terna Medical College",
    college: "Terna Medical College",
    tag: "NEET",
    tagColor: "#166534",
    initials: "DG",
  },
  {
    name: "Gaurav Chothe",
    score: "Boards 95% | NEET 572 Marks",
    exam: "MBBS – GMC Alibag",
    college: "GMC Alibag",
    tag: "NEET",
    tagColor: "#166534",
    initials: "GC",
  },
];

const stats = [
  { value: "7+", label: "Documented Toppers" },
  { value: "572+", label: "Best NEET Score" },
  { value: "95%", label: "Best HSC Score" },
  { value: "93.82%tile", label: "Best JEE Percentile" },
];

export default function Results() {
  return (
    <div data-testid="results-page" className="pt-16 md:pt-20">
      {/* Header */}
      <section className="page-header py-14 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-xs font-bold tracking-widest uppercase mb-3" style={{ color: "#F2C94C" }}>
            Student Achievements
          </p>
          <h1
            className="text-4xl md:text-6xl font-extrabold text-white mb-4"
            style={{ fontFamily: "Manrope, sans-serif" }}
          >
            Our Results
          </h1>
          <p className="text-blue-200 text-base md:text-lg max-w-2xl mx-auto">
            Our students' success in NEET, JEE, MHT-CET, and HSC board examinations is our greatest achievement.
          </p>
          <nav className="flex items-center justify-center gap-2 mt-6 text-xs text-blue-300">
            <Link to="/" className="hover:text-yellow-400 transition-colors">Home</Link>
            <ChevronRight size={12} />
            <span className="text-yellow-400">Results</span>
          </nav>
        </div>
      </section>

      {/* Stats */}
      <section
        data-testid="results-stats-section"
        style={{ backgroundColor: "#0A2540" }}
        className="py-10"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {stats.map((s, i) => (
              <div key={i} className="text-center" data-testid={`result-stat-${i}`}>
                <div className="stat-number">{s.value}</div>
                <div className="text-gray-300 text-sm mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Results image */}
      <section data-testid="results-image-section" className="py-14 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2
              className="text-2xl md:text-3xl font-extrabold"
              style={{ color: "#0A2540", fontFamily: "Manrope, sans-serif" }}
            >
              Our <span style={{ color: "#F2C94C" }}>Proud Toppers</span>
            </h2>
            <div className="section-divider mt-3"></div>
          </div>
          <img
            src={RESULTS_IMG}
            alt="Trident Academy Toppers"
            className="w-full rounded-2xl shadow-2xl"
          />
        </div>
      </section>

      {/* Topper cards grid */}
      <section data-testid="toppers-grid-section" className="py-14 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <h2
              className="text-2xl md:text-3xl font-extrabold"
              style={{ color: "#0A2540", fontFamily: "Manrope, sans-serif" }}
            >
              Individual Achievements
            </h2>
            <div className="section-divider mt-3"></div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {toppers.map((t, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl p-6 text-center border border-gray-100 card-hover"
                data-testid={`topper-card-${i}`}
              >
                {/* Avatar */}
                <div
                  className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center text-xl font-extrabold text-white"
                  style={{ backgroundColor: "#0A2540" }}
                >
                  {t.initials}
                </div>

                {/* Stars */}
                <div className="flex justify-center gap-1 mb-3">
                  {[...Array(5)].map((_, j) => (
                    <Star key={j} size={12} fill="#F2C94C" color="#F2C94C" />
                  ))}
                </div>

                {/* Tag */}
                <span
                  className="text-xs font-bold px-3 py-1 rounded-full text-white inline-block mb-3"
                  style={{ backgroundColor: t.tagColor }}
                >
                  {t.tag}
                </span>

                {/* Name */}
                <h3
                  className="font-extrabold text-base mb-1"
                  style={{ color: "#0A2540", fontFamily: "Manrope, sans-serif" }}
                >
                  {t.name}
                </h3>

                {/* Score */}
                <p
                  className="text-sm font-semibold mb-1"
                  style={{ color: "#F2C94C" }}
                >
                  {t.score}
                </p>

                {/* Exam */}
                <p className="text-xs text-gray-400">{t.exam}</p>
              </div>
            ))}

            {/* And more card */}
            <div
              className="rounded-2xl p-6 text-center flex flex-col items-center justify-center"
              style={{ background: "linear-gradient(135deg, #0A2540, #0d3362)" }}
              data-testid="and-more-card"
            >
              <Award size={32} color="#F2C94C" className="mb-3" />
              <h3
                className="font-extrabold text-xl text-white mb-2"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                And many more...
              </h3>
              <p className="text-blue-200 text-xs mb-4">
                50+ students have achieved top ranks across NEET, JEE, and MHT-CET.
              </p>
              <Link
                to="/contact"
                data-testid="results-enquire-btn"
                className="text-xs font-bold px-4 py-2 rounded-lg transition-all hover:opacity-90"
                style={{ backgroundColor: "#F2C94C", color: "#0A2540" }}
              >
                Join Our Success Story
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section
        className="py-14 bg-gray-50"
      >
        <div className="max-w-2xl mx-auto px-4 text-center">
          <h2
            className="text-2xl md:text-3xl font-extrabold mb-3"
            style={{ color: "#0A2540", fontFamily: "Manrope, sans-serif" }}
          >
            Be Our Next <span style={{ color: "#F2C94C" }}>Topper</span>
          </h2>
          <p className="text-gray-500 text-sm mb-6">
            Join Trident Academy and let our expert faculty guide you to your dream score.
          </p>
          <Link
            to="/contact"
            data-testid="results-cta-btn"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-xl font-bold text-sm transition-all hover:opacity-90"
            style={{ backgroundColor: "#0A2540", color: "white" }}
          >
            Enquire Now <ChevronRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
